import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React , {useEffect} from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import {useShowSingleArticleQuery,useUpdateArticleMutation} from "../../../Services/api";
export default function UpdateArticle(props) {
    const notify = () => '';
    const validationSchema = Yup.object().shape({
        title: Yup.string().required("title fields is required"),
        link: Yup.string().required("link fields is required"),
    }); 
      const {
        data: ShowArticleSingle,
        
      } =  useShowSingleArticleQuery({  params:props['id']});

      const [UpdateArticle,isLoading] = useUpdateArticleMutation();
      
      const Article= ShowArticleSingle? ShowArticleSingle?.data[0] : 0;
     
   
      var  defaultValues={
        title:Article?.title,
        link:Article?.link,
        id:Article?.id ?? 0,
      };
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues: defaultValues,
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
      } = methods;
      useEffect(() => {
        reset(defaultValues)
      },[Article]) 
    const editArticle = (values,e) => {
        
        UpdateArticle({ data: values,param:props['id'] })
        .unwrap()
        .then((payload) => {
            if (payload.status) {
              toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error)
        });
        notify();
    };
   
    return (
        
        <div className="modal fade" id="fullscreenModalArticle">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Article</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                        <h5 className="card-title">Update Article</h5>
                        <form onSubmit={handleSubmit(editArticle)} >

                                <div className="row mb-3">
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Title</label>
                                    <div className="col-sm-10">
                                        <input type="name" {...register("title" ,{ required: true})} className="form-control" />
                                        {errors.title && <span  className="text-danger">Title is required</span>}
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize"> Link </label>
                                    <div className="col-sm-10">
                                        <input type="text" {...register('link' ,{ required: true })} className="form-control" />
                                        {errors.link && <span  className="text-danger">Link  is required</span>}
                                    </div>
                                   
                                </div>
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label"></label>
                                <div className="col-sm-10">
                                        {isLoading.status !=='pending' ?        
                                        <button type="submit" className="btn btn-warning w-100" >Update Article</button>
                                                :
                                        <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                    }
                                </div>
                            </div>
                        </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    );
}